import React, { useContext } from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import FavStarOutline from '../../../Icons/FavStarOutline';
import FavStarFilled from '../../../Icons/Favourite';
import { MobileContext } from '../../../Context';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { BiEventType, BiDataHook } from '../../../biLogger/constants';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
export var FavouriteButton = function (_a) {
    var deviation = _a.deviation, actionBarType = _a.actionBarType, onShowMobileCollectionsPanel = _a.onShowMobileCollectionsPanel, onToggleCollectionPanel = _a.onToggleCollectionPanel, isCollectionPanelOpen = _a.isCollectionPanelOpen;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isFavourited = deviation.isFavourited;
    var onClick = function () {
        return isMobile
            ? onShowMobileCollectionsPanel(deviation)
            : onToggleCollectionPanel(actionBarType);
    };
    return (React.createElement(ActionBarButton, { onClick: onClick, dataHook: BiDataHook.DEVIATION_FAVES_COUNTER, biData: isCollectionPanelOpen
            ? undefined
            : {
                evid: BiEventType.ADD_TO_COLLECTION_CLICK,
                creatorid: get(deviation, 'author.useridUuid'),
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                sectionname: undefined,
            } },
        React.createElement(ActionBarIcon, { isActive: isFavourited, icon: isFavourited ? FavStarFilled : FavStarOutline, label: t(isFavourited ? 'actionbar.inFavourites' : 'actionbar.addToFavourites') })));
};
FavouriteButton.displayName = 'FavouriteButton';
export default FavouriteButton;
//# sourceMappingURL=FavouriteButton.js.map